<div class="bcg p-4 ">
    <div class="row">
        <div class="col-lg-7 col-sm-7 col-md-7 mb-3">
            <p class="nav_link_cat ms-1  flex_row">
                <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
                <span [style.font-weight]="'bold'"> >> </span>
                <span>Reports Summary</span>
            </p>
        </div>
        <div class="col-lg-2 col-sm-2 col-md-2 "></div>
        <div class="col-lg-3 col-sm-3 col-md-3 overlay text-right">
            <!-- <p-select  class="custom-dropdown text-left" placeholder="Select Branch" [options]="states" [(ngModel)]="selectedState" (click)= getSelected()   optionLabel="name"></p-select> -->
        </div>
    </div>

    <div class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">Reports</h5>
                    <p class="card-text text_p ">View Summary of the Orders</p>
                </div>
                <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
                    <!-- <p-button label="Export" (click)="export()" icon="bx bx-export"
                        styleClass="p-button-sm-outline"></p-button> -->
                    <p-button class="ms-1" label="Back" (click)="gotoDashboard()"
                        styleClass="p-button-sm-outline"></p-button>

                </div>
            </div>
        </div>
    </div>
    <div class="card card_outLine mt-3">
        <div class="card-body">

            <app-tab-view [tabs]="reportsTabs" [activeIndex]="tabIndex" (tabChange)="onChangeTab($event)">
                <ng-container *ngIf="tabIndex === 0">

                    <div class="row mb-3 mt-4">
                        <h5 class="title_five">Order Summary</h5>
                    </div>
                    <div class="row" style="padding-top: 10px">
                        <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                            <p class="filter-label">Account</p>
                            <app-dropdown class="custom-dropdown text-left" placeholder="Select Account" [filter]="true"
                                [showClear]="true" filterBy="account_name" [options]="accounts"
                                [(ngModel)]="selectedAccountForSummary" (onChange)="onChangeAccount($event)"
                                optionLabel="account_name" optionValue="id"
                                (onFilter)="onAccountFilter($event)"></app-dropdown>
                        </div>
                        <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                            <p class="filter-label">State</p>

                            <app-dropdown class="custom-dropdown text-left" placeholder="Select State"
                                [options]="states" [showClear]="true" [filter]="true" filterBy="state_name"
                                [(ngModel)]="selectState" (onChange)="onChangeState($event)" optionLabel="state_name"
                                optionValue="id"></app-dropdown>
                        </div>
                        <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                            <p class="filter-label">Branch</p>
                            <app-dropdown class="custom-dropdown text-left" [options]="branches" [filter]="true"
                                [showClear]="true" filterBy="name" (onChange)="onChangeBranch($event)"
                                optionLabel="name" placeholder='Select Branch' optionValue="id"></app-dropdown>
                        </div>
                        <div class="col-lg-3 col-sm-3 col-md-3 overlay">
                            <p class="filter-label">Date Range</p>

                            <p-datepicker #calendar class="custom-calendar" [(ngModel)]="rangeDates"
                                [showButtonBar]="true" (onSelect)="onSelect()" placeholder="Filter Range"
                                [showIcon]="true" iconDisplay="input" selectionMode="range" [readonlyInput]="false"
                                appendTo="body" inputId="range" (ngModelChange)="onDateRangeChange($event)"
                                [maxDate]="maxDate" dateFormat="dd/mm/yy">
                            </p-datepicker>
                        </div>
                        <div class="col-lg-2 col-sm-2 col-md-2 overlay"></div>
                        <div class="col-lg-1 col-sm-1 col-md-1 text-right custom_button mt-3">
                            <p-button class="ms-1" label="Apply" (click)="filterState(reportFilters)"
                                styleClass="p-button-sm-outline"></p-button>
                        </div>
                    </div>

                    <div class="flex_row border_report">
                        <div class="col-lg-3 col-sm-3 col-md-3 pt-3">
                            <div class="row">
                                <div class="col-lg-7 col-sm-7 col-md-7 order_font ms-3">{{summaryReportData[0].count}}
                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right"
                                    style="border-right: 1px solid #D9D9D9;">
                                    <i class={{summaryReportData[0].icon}}></i>
                                </div>
                                <p class="order_report ms-3">{{summaryReportData[0].name}}</p>
                            </div>

                        </div>

                        <div class="col-lg-3 col-sm-3 col-md-3 pt-3">
                            <div class="row">
                                <div class="col-lg-7 col-sm-7 col-md-7 order_font ms-3">{{summaryReportData[7].count}}
                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right"
                                    style="border-right: 1px solid #D9D9D9;">
                                    <i class={{summaryReportData[0].icon}}></i>
                                </div>
                                <p class="order_report ms-3">{{summaryReportData[7].name}}</p>
                            </div>

                        </div>
                        <div class="col-lg-3 col-sm-3 col-md-3 py-3 ">
                            <div class="row">
                                <div class="col-lg-7 col-sm-7 col-md-7 order_font ms-3">{{summaryReportData[1].count}}
                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right "
                                    style="border-right: 1px solid #D9D9D9;">
                                    <i class={{summaryReportData[1].icon}}></i>
                                </div>
                                <p class="order_report ms-3">{{summaryReportData[1].name}}</p>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-3 col-md-3 py-3">
                            <div class="row">
                                <div class="col-lg-7 col-sm-7 col-md-7 order_font ms-3">{{summaryReportData[2].count}}
                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right"
                                    style="border-right: 1px solid #D9D9D9;">
                                    <i class={{summaryReportData[2].icon}}></i>
                                </div>
                                <p class="order_report ms-3">{{summaryReportData[2].name}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex_row border_report">
                        <div class="col-lg-3 col-sm-3 col-md-3 pt-3">
                            <div class="row">
                                <div class="col-lg-7 col-sm-7 col-md-7 order_font ms-3">{{summaryReportData[4].count}}

                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right"
                                    style="border-right: 1px solid #D9D9D9;">
                                    <i class={{summaryReportData[4].icon}}></i>

                                </div>
                            </div>
                            <p class="order_report ms-3">{{summaryReportData[4].name}}</p>


                        </div>
                        <div class="col-lg-3 col-sm-3 col-md-3 py-3 ">
                            <div class="row">
                                <div class="col-lg-7 col-sm-7 col-md-7 order_font ms-3">{{summaryReportData[5].count}}

                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right "
                                    style="border-right: 1px solid #D9D9D9;">
                                    <i class={{summaryReportData[5].icon}}></i>

                                </div>
                            </div>
                            <p class="order_report ms-3">{{summaryReportData[5].name}}</p>


                        </div>
                        <div class="col-lg-3 col-sm-3 col-md-3 py-3">
                            <div class="row">
                                <div class="col-lg-7 col-sm-7 col-md-7 order_font ms-3">{{summaryReportData[6].count}}

                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right"
                                    style="border-right: 1px solid #D9D9D9;">
                                    <i class={{summaryReportData[6].icon}}></i>

                                </div>
                            </div>
                            <p class="order_report ms-3">{{summaryReportData[6].name}}</p>

                        </div>
                        <div class="col-lg-3 col-sm-3 col-md-3 py-3">
                            <div class="row">
                                <div class="col-lg-7 col-sm-7 col-md-7 order_font ms-3">₹ {{summaryReportData[3].count}}
                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right">
                                    <i class={{summaryReportData[3].icon}}></i>

                                </div>
                                <p class="order_report ms-3"> {{summaryReportData[3].name}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex_row border_report">
                        <div class="col-lg-3 col-sm-3 col-md-3 py-3">
                            <div class="row">
                                <div class="col-lg-7 col-sm-7 col-md-7 order_font ms-3">
                                    {{summaryReportData[8].count}}
                                </div>

                                <div class="col-lg-3 col-sm-3 col-md-3 text-right">
                                    <i class="icon_color bx bx-calendar-x bx-md"></i>
                                </div>

                                <p class="order_report ms-3">
                                    {{summaryReportData[8].name}}
                                </p>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="tabIndex === 1">

                    <div class="row" style="padding-top: 10px">
                        <div class="col-lg-2 col-sm-2 col-md-2 overlay_1" style="padding-left:1.5rem">
                            <p class="filter-label">Account</p>
                            <app-dropdown class="custom-dropdown text-left" placeholder="Select Account" [filter]="true"
                                [showClear]="true" filterBy="account_name" [options]="accounts"
                                [(ngModel)]="selectedAccountForStampDashboard" (onChange)="onAccountChange($event)"
                                optionLabel="account_name" optionValue="id"
                                (onFilter)="onAccountFilter($event)"></app-dropdown>
                        </div>
                        <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                            <p class="filter-label">State</p>
                            <app-dropdown class="custom-dropdown text-left" placeholder="Select State"
                                [options]="states" [filter]="true" filterBy="state_name" [(ngModel)]="selectState"
                                [showClear]="true" (onChange)="onStateChange($event)" optionLabel="state_name"
                                optionValue="id"></app-dropdown>
                        </div>
                        <div class="col-lg-2 col-sm-2 col-md-2 offset-6 export-stamp-dashboard">
                            <p-button label="Export" (click)="exportStampDashboardData()" icon="bx bx-export"
                                styleClass="p-button-sm-outline"></p-button>
                            <app-column-chooser [table]="stampDashboardTable"></app-column-chooser>
                        </div>
                    </div>

                    <!-- <app-stamp-dahsboard-view></app-stamp-dahsboard-view> -->
                    <div class="row m-2 mt-3">
                        <app-data-table #stampDashboardTable [columnChooser]="true" [columns]="stampDashboardColumns"
                            [data]="stampDashboardData" [paginator]="false" emptyMessage="No Records Found">
                            <ng-template appTableCell="amount" let-row>
                                ₹{{ row.amount }}
                            </ng-template>
                        </app-data-table>
                    </div>
                </ng-container>

                <ng-container *ngIf="tabIndex === 2">
                    <div class="consumption-row" *ngIf="!isShowDailyReports" style="padding-top: 10px">
                        <div class="consumption-filters">

                            <div class="overlay_1  ">
                                <p class="filter-label">Account</p>
                                <app-dropdown class="custom-dropdown text-left" placeholder="Select Account"
                                    (onChange)="onChangeAccount($event)" [options]="accounts" [filter]="true"
                                    filterBy="account_name" [(ngModel)]="selectedAccountForConsmpReport"
                                    [showClear]="true" optionLabel="account_name" optionValue="id"
                                    (onFilter)="onAccountFilter($event)"></app-dropdown>
                            </div>

                            <div class="overlay_1  ">
                                <p class="filter-label">Time Period</p>
                                <app-dropdown class="custom-dropdown text-left" placeholder="Select Period"
                                    (onChange)="onSelectConsumpReportDateValue($event)" [options]="dateRanges"
                                    optionLabel="name" optionValue="code" [(ngModel)]="selectedPeriod"
                                    [sort]="false"></app-dropdown>
                            </div>

                            <div class="overlay ">
                                <p class="filter-label">Date Range</p>
                                <p-datepicker #calendarConsumpReport class="custom-calendar" [(ngModel)]="rangeDates3"
                                    [maxDate]="maxDateForConsumption" (onSelect)="onSelectConsumpReportDate()"
                                    placeholder="Select Custom Date" [showIcon]="true" iconDisplay="input"
                                    dateFormat="dd/mm/yy" selectionMode="range" appendTo="body" [readonlyInput]="false"
                                    inputId="range" [showButtonBar]="true"
                                    (ngModelChange)="onDateRangeChangeForConsumpReport($event)">
                                </p-datepicker>
                            </div>
                        </div>
                        <div class="">
                            <p-button label="Export" (click)="getConsumptionReport()" icon="bx bx-export"
                                styleClass="p-button-sm-outline"
                                [disabled]="selectedAccountForConsmpReport === '' || 
                                (consumptionReportFilters.start_date === '' || consumptionReportFilters.end_date === '')"></p-button>

                            <p-button class="ms-2" label="Daily Report" (click)="showExportReports()"
                                styleClass="p-button-sm"></p-button>
                        </div>

                    </div>

                    <div class="card card_outLine mt-3" *ngIf="!isShowDailyReports">

                        <div class="card-body">
                            <div class="flex-row">
                                <ng-container
                                    *ngFor="let optionGroup of checkboxOptionsForConsumpReport; let i = index">
                                    <div class="checkbox-column">
                                        <label>
                                            <input type="checkbox" [(ngModel)]="optionGroup.checked">
                                            <span class="r1s">{{ optionGroup.fieldName }}</span>
                                        </label>
                                    </div>
                                </ng-container>
                            </div>

                            <div class="mt-3">
                                <p-button label="Save" icon="pi pi-save" (click)="saveConsumptionReportColumns()"
                                    styleClass="p-button-sm"></p-button>
                            </div>
                        </div>
                    </div>

                    <div class="daily-reports" *ngIf="isShowDailyReports">
                        <div class="consumption-row">
                            <div class="consumption-filters">
                                <div class="overlay_1">
                                    <app-dropdown class="custom-dropdown text-left" placeholder="Select Account"
                                        [filter]="true" [showClear]="true" filterBy="account_name" [options]="accounts"
                                        (onChange)="onChangeAccountForDailyReport($event)" optionLabel="account_name"
                                        optionValue="id" (onFilter)="onAccountFilter($event)"
                                        [(ngModel)]="selectedAccountForDailyReport"></app-dropdown>
                                </div>
                                <div class="overlay_1">
                                    <app-dropdown class="custom-dropdown text-left" placeholder="Select State"
                                        [options]="states" [filter]="true" filterBy="state_name"
                                        [(ngModel)]="selectState" [showClear]="true"
                                        (onChange)="onChangeStateForDailyReport($event)" optionLabel="state_name"
                                        optionValue="id"></app-dropdown>
                                </div>
                                <div class="overlay_1">
                                    <app-dropdown class="custom-dropdown text-left" [options]="branches" [filter]="true"
                                        [showClear]="true" filterBy="name"
                                        (onChange)="onChangeBranchForDailyReport($event)" optionLabel="name"
                                        placeholder='Select Branch' optionValue="id"
                                        [(ngModel)]="selectedBranchForDailyReport"></app-dropdown>
                                </div>
                                <div class="overlay">
                                    <p-datepicker #calendarDailyReport class="custom-calendar"
                                        [(ngModel)]="dailyReportDaterange" [maxDate]="maxDate" [showButtonBar]="true"
                                        (onSelect)="onSelectDailyReportDate()" placeholder="Filter Range"
                                        dateFormat="dd/mm/yy" appendTo="body" [showIcon]="true" iconDisplay="input"
                                        selectionMode="range" [readonlyInput]="false" inputId="range"
                                        (ngModelChange)="onDateRangeChangeForDailyReport($event)">
                                    </p-datepicker>
                                </div>
                            </div>

                            <div class="">
                                <p-button label="Back" (click)="showConsumptionReport()"
                                    styleClass="p-button-sm"></p-button>
                                <p-button label="Export" (click)="export()" icon="bx bx-export"
                                    styleClass="p-button-sm-outline" class="ms-2"></p-button>
                            </div>
                        </div>

                        <div class="card card_outLine mt-3">
                            <div class="card-body">
                                <div class="flex-row">
                                    <ng-container *ngFor="let optionGroup of checkboxOptions; let i = index">
                                        <div class="checkbox-column">
                                            <label>
                                                <input type="checkbox" [(ngModel)]="optionGroup.checked"
                                                    (change)="onCheckboxChange(optionGroup)" checked>
                                                <span class="r1s">{{ optionGroup.fieldName }}</span>
                                            </label>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                        </div>
                    </div>

                </ng-container>
            </app-tab-view>
        </div>
    </div>
</div>

<div class="toast_display_layer">
    <p-toast></p-toast>
</div>